import React from 'react';
import { formatBytes } from '../otaEvents/utils';
import { FIRMWARE_FILE_FIELDS } from './constants';
import { formatChannel, formatDateTime, formatValue } from './utils';

const FIELD_FORMATTERS = {
  version: formatValue,
  channel: formatChannel,
  file_name: formatValue,
  size: formatBytes,
  modified_at: formatDateTime,
};

const FirmwareFile = ({ file }) => (
  <div className="flex flex-col gap-1 py-3 text-sm text-gray-600 sm:flex-row sm:flex-wrap sm:gap-x-6">
    {FIRMWARE_FILE_FIELDS.map(({ key, label, emphasize, className }) => {
      const value = FIELD_FORMATTERS[key](file?.[key]);

      return (
        <span key={key} className={className}>
          {label}: {emphasize ? <span className="font-medium text-gray-800">{value}</span> : value}
        </span>
      );
    })}
  </div>
);

export default FirmwareFile;
